export class PrivateKeyError extends Error {
  public constructor(message: string) {
    super(message);
  }
}

export class IdentifierError extends Error {
  public constructor(message: string) {
    super(message);
  }
}

export class StampError extends Error {
  public constructor(message: string) {
    super(message);
  }
}

export class ReactionError extends Error {
  public constructor(message: string) {
    super(message);
  }
}
